import { useCallback } from "react";
import { useUserStore } from "../../stores/user.store";

interface LabelledItem {
	participantName?: string;
	cin?: string;
}

// SIMS-7579: a coordinator holding the DASH_EVT_BEN_CIN_VIEW access code sees a
// participant's CIN instead of their name — a per-user display preference that
// supersedes the account's displayBeneficiaryName (same behavior as the
// dashboard narrative). `participantName` is already account-resolved by the
// backend, so for a non-code user it may itself be the CIN when names are
// hidden; this hook only adds the per-user CIN override on top.
export const useParticipantLabel = (): ((item: LabelledItem) => string) => {
	const showCIN = useUserStore((state) =>
		state.userHasAccessToCode("DASH_EVT_BEN_CIN_VIEW"),
	);
	return useCallback(
		(item: LabelledItem) => {
			// A code-holder must never fall back to the name — if the CIN is
			// somehow absent, show a generic label instead of leaking the name.
			if (showCIN) {
				return item.cin || "Participant";
			}
			return item.participantName || "Participant";
		},
		[showCIN],
	);
};
